<template>
    <div style="padding-left: 15px;">
        <div   class="classcut clearfix">
            <div class="fl">一年级一班</div>
            <div class="fr" @click="bookcut()">切换</div>
        </div>
        <el-row  class="classcut2">
            <el-col :span="6">{{this.form.sname}}</el-col>
            <el-col :span="18">{{this.form.bookname}}</el-col>
        </el-row>
        <div @click="readover(2)"  class="classcuts clearfix" style="display:none;">
            <div class="fl">未批阅</div>
            <div class="fr">4</div>
        </div>
        <!-- //任务 -->
        <el-tree class="treelist"  :data="taskdata" accordion :props="defaultProps" @node-click="handleNodeClick"></el-tree>
        <!-- //错题集 -->
        <el-tree class="treelist"  style="display:none;" :data="data2" accordion :props="defaultProps" @node-click="handleNodeClick2"></el-tree>

        <el-dialog title="" :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="bookcutpopup">
            <el-form :model="form">
                <el-form-item label="年级:" :label-width="formLabelWidth">
                     <el-select v-model="form.region1" placeholder="请选择年级" >
                        <el-option v-for="item in this.gradedata" :key="item.gid" :label="item.grade_name" :value="item.gid" @click.native="changegid(item)"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="科目:" :label-width="formLabelWidth">
                     <el-select v-model="form.region2" placeholder="请选择科目" >
                        <el-option v-for="item in this.subjectdata" :key="item.sid" :label="item.subject_name" :value="item.sid" @click.native="changesid(item)" ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="版本:" :label-width="formLabelWidth">
                    <el-select v-model="form.region3" placeholder="请选择版本">
                        <el-option v-for="item in this.booklist" :key="item.book_id" :label="item.book_name" :value="item.book_id" @click.native="changebookid(item)"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitform">确 定</el-button>
            </div>
        </el-dialog>


    </div>
</template>
<script>
import eventBus from "@/api/eventBus";
import URL from '@/api/index'
export default {
    data() {
        return{
            taskdata: [],
            defaultProps: {
                children: 'son',
                label: 'chapter_name',
                type:'1'
            },
            data2: [{
                label: '错题集',
                val: '21',
                text: '错题集',
                children: [{
                    label: '二级 1-1',
                    val: '21',
                    text: '错题集',
                    children: [{
                        label: '三级 1-1-1',
                        val: '21',
                        text: '错题集',
                    }]
                }]
            }],
            abc:'0',
            dialogFormVisible: false,
            form: {
                region1: 1,
                region2: 1,
                region3: '',
                gname:'',
                sname:'',
                bookname:'',
            },
            Gid: 1,
            Sid: 1,
            Bookid:'',
            formLabelWidth: '120px',
            gradedata:[],
            subjectdata:[],
            booklist:[],
        }
    },
    mounted(){
        // zjgradeCopy 年级  zjsidCopy 学科
        //年级
        if (JSON.parse(localStorage.getItem("zjgradeCopy"))) {
            this.Gid = JSON.parse(localStorage.getItem("zjgradeCopy"))
            this.Sid = JSON.parse(localStorage.getItem("zjsidCopy"))
            this.form.region1 = JSON.parse(localStorage.getItem("zjgradeCopy"))
            // console.log(this.form)
        }
        // this.Sid
        // console.log(this.Gid)
        this.getallgrade()
        // this.getgetsubject();
        // this.getbooklist();
        // this.getbookchapter()
    },
    methods: {
        //选择年级 重新获取科目和课本
        changegid(val){
            // console.log(val,"211211")
            this.Gid = val.gid
            this.form.gname = val.grade_name
            this.getgetsubject()
            eventBus.$emit("gid",val) 
        },
        //选择科目  重新获取课本
        changesid(val){
            this.Sid = val.sid
            this.form.sname = val.subject_name
            this.getbooklist();   
        },
        //选择课本
        changebookid(val){
            this.Bookid = val.book_id
            this.form.bookname = val.book_name
            this.getbookchapter();
        },
        //获取年级
        getallgrade(){
            this.$post(URL.allgrade).then( res =>{
                this.gradedata = res.result.grade_list
                //初始化默认第一个
                this.form.gname = res.result.grade_list[0].grade_name
                this.getgetsubject();
            })
        },
        //获取科目
        getgetsubject(){
            var subjectval = {
                gid: this.Gid,
            }
            this.$post(URL.getsubject,subjectval).then( res=>{
                this.subjectdata = res.result.subject_list
                //默认是第一个科目
                
                if (JSON.parse(localStorage.getItem("zjgradeCopy"))) {
                    this.form.region2 = JSON.parse(localStorage.getItem("zjsidCopy"))
                    var nameinx = JSON.parse(localStorage.getItem("zjsidCopy"))
                    this.form.sname = res.result.subject_list[nameinx-1].subject_name
                }else{
                    this.form.region2 = res.result.subject_list[0].sid
                    this.form.sname = res.result.subject_list[0].subject_name
                }
                
                eventBus.$emit("subdata",res.result.subject_list) 
            })
            this.getbooklist()
        },
        //获取课本
        getbooklist(){
            var bookdata={
                gid: this.Gid,
                sid: this.Sid
            }
            this.$post(URL.getbooklist,bookdata).then( res=>{
                this.booklist = res.result.booklist
                this.form.region3 = res.result.booklist[0].book_id
                this.form.bookname = res.result.booklist[0].book_name
                this.Bookid = res.result.booklist[0].book_id
                this.getbookchapter();
            })
        },
        //课本内容
        getbookchapter(){
            var bookchapterdata = {
                cptid: this.Bookid
            }
            this.$post(URL.bookchapter,bookchapterdata).then( res =>{
                // console.log(res.result.menu)
                this.taskdata = res.result.menu
            })
        },

        //树形控件点击  任务
      handleNodeClick(data) {
        // console.log(data)
        // eventBus.$emit("treedata",data.text)  
      },
      //错题集
      handleNodeClick2(data){
        // eventBus.$emit("treedata",data.text)  
      },
      //未批阅
      readover(val){
        // eventBus.$emit("treedata",val)  
      },
      bookcut(){
        this.dialogFormVisible = true
      },
      submitform(){
        //   console.log(this.form)
          this.dialogFormVisible = false

      },

      
    }   
}
</script>